export const LiraContainerIds = {
  page410: {
    skyscraperLeft: 'errorgone-skyscraperleft',
    skyscraperRight: 'errorgone-skyscraperright',
    belowTheFold: 'errorgone-belowthefold',
  },
  pageError: {
    skyscraperLeft: 'errornotfound-skyscraperleft',
    skyscraperRight: 'errornotfound-skyscraperright',
    belowTheFold: 'errornotfound-belowthefold',
  },
  adView: {
    skyscraperLeft: 'adview-skyscraper-left',
    skyscraperRight: 'adview-skyscraper-right',
    //When we are full on Lira, we should use this id adview-skin instead of apn_skin_tag
    skin: 'apn_skin_tag',
    bottom: 'adview-bottom',
    top: 'adview-top',
    aside: 'adview-aside',
    aside2: 'adview-aside2',
    boxBelow1: 'adview-boxbelow1',
    boxBelow2: 'adview-boxbelow2',
    boxBelow3: 'adview-boxbelow3',
    // Lazy components:
    replyBox: 'adview-intothereplybox',
    belowGallery: 'adview-belowgallery',
    anchorGallery: 'adview-anchorgallery',
    sponsorGallery: 'adview-sponsorgallery',
    vehicleHistory: 'adview-vehicle-history',
    vehicleHistory2: 'adview-vehicle-history-2',
    //TODO: please standardize the name of this container
    videoPreroll: 'video_preroll',
    imageIntoGalleryForPro: 'apn_gallery_adview',
    imageIntoGalleryForProMsite: 'apn_gallery_adview_msite',
    imageIntoGalleryForPrivate: 'apn_gallery_adv_adview',
    imageIntoGalleryForPrivateMsite: 'apn_gallery_adv_adview_msite',
  },
  listing: {
    skin: 'apn_skin_tag',
    top: 'listing-top',
    aside: 'listing-aside',
    skyscraperLeft: 'listing-skyscraper-left',
    skyscraperRight: 'listing-skyscraper-right',
    inContentTop: 'listing-in-content-top',
    interstitial: 'interstitial',
    interstitialLazy: 'interstitial-lazy',
    box1: 'listing-box-1',
    box2: 'listing-box-2',
    box3: 'listing-box-3',
    inContentBottom: 'listing-in-content-bottom',
    zeroResult: 'listing-zero-result',
  },
};
